<div class="main-page-content">
  <div class="main-page-content-block">

    <div class="main-page-content-block" *ngIf="currentItem!=null">
      <div class="float-end">

        <span *ngIf="loading" class="mr-3" role="status" >Loading ...</span>
        <button class="btn btn-secondary " type="button" [routerLink]="['/clients']" [disabled]="loading">View list</button>
      </div>

      <h1 class="content-heading-font">
        <img [src]="getClientLogo()" class="bussinesLogo d-lg-inline-block" *ngIf="currentItem.Active" />
        {{currentItem.BusinessName || currentItem.SiteName }}
      </h1>

      <div class="row" *ngIf="clientStatus!=null">
        <div class="col-12 col-lg mb-4" *ngIf="metrics!=null">
          <div class="main-ticket-metrics bg-dark ">
            <div class="row ">
              <div class="main-ticket-metrics-item round-10">
                <div class="pl-1 pr-1">
                  Current Open Tickets:
                </div>
                <div>
                  {{ metrics.TotalOpenTicketsCount }}
                </div>
              </div>
              <div class="main-ticket-metrics-item round-10">
                <div class="pl-1 pr-1">
                  Tickets Closed > 7 Days:
                </div>
                <div>
                  {{  metrics.TicketsClosedInLastSevenDaysCount }}
                </div>
              </div>
              <div class="main-ticket-metrics-item round-10">
                <div class="pl-1 pr-1">
                  Critical Tickets:
                </div>
                <div>
                  {{  metrics.CriticalTicketsCount }}
                </div>
              </div>
              <div class="main-ticket-metrics-item round-10">
                <div class="pl-1 pr-1">
                  Oldest Open Ticket:
                </div>
                <div>
                  <span title="{{ metrics.OldestTicketDate | date: 'short' }}"> {{ getTimeFromNow( metrics.OldestTicketDate) }}</span>
                </div>
              </div>
              <div class="main-ticket-metrics-item round-10">
                <div class="round-10 pl-1 pr-1">
                  Tickets With No Response
                </div>
                <div>
                  {{ metrics == null ? 0 : metrics.TicketsWithNoResponseCount }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-lg mb-4">
          <div class="main-ticket-metrics bg-danger fw-bolder fs-4 p-3 " *ngIf="clientStatus.ClientError">
            <p>Error: {{ clientStatus.ClientError }}</p>
          </div>
          <div class="main-ticket-metrics bg-info " *ngIf="!clientStatus.ClientError">
            <div class="row ">
              <div class="main-ticket-metrics-item round-10">
                <div class="pl-1 pr-1">
                  Last Login:
                </div>
                <div>
                  <span title="{{ clientStatus.LastLogin | date: 'short' }}"> {{ getTimeFromNow(clientStatus.LastLogin) }}</span>
                </div>
              </div>
              <div class="main-ticket-metrics-item round-10">
                <div class="pl-1 pr-1">
                  Last Service Created:
                </div>
                <div>
                  <span title="{{ clientStatus.LastServiceCreated | date: 'short' }}"> {{ getTimeFromNow(clientStatus.LastServiceCreated) }}</span>
                </div>
              </div>
              <div class="main-ticket-metrics-item round-10">
                <div class="pl-1 pr-1">
                  Last Transmission Received:
                </div>
                <div>
                  <span title="{{ clientStatus.LastTransmissionReceived | date: 'short' }}"> {{ getTimeFromNow(clientStatus.LastTransmissionReceived) }}</span>
                </div>
              </div>
              <div class="main-ticket-metrics-item round-10">
                <div class="pl-1 pr-1">
                  Last Transmission Sent:
                </div>
                <div>
                  <span title="{{ clientStatus.LastTransmissionSent | date: 'short' }}"> {{ getTimeFromNow(clientStatus.LastTransmissionSent) }}</span>
                </div>
              </div>
              <div class="main-ticket-metrics-item round-10">
                <div class="pl-1 pr-1">
                  Last Incident Report:
                </div>
                <div>
                  <span title="{{ clientStatus.LastIncidentReport | date: 'short' }}"> {{ getTimeFromNow(clientStatus.LastIncidentReport) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg mb-4 " *ngIf="clientUsers && clientUsers.length > 0">
          <div class="list-group border-1   ">
            <li class="list-group-item text-center font-bolder fs-5">Login as Client Users</li>
            <button *ngFor="let clientUser of clientUsers; let i = index"
                    class="list-group-item list-group-item-action  "
                    type="button" (click)="clientLogin(clientUser)" [disabled]="loading">
              <div class="float-right text-muted">
                #{{ clientUser.ID }} {{ clientUser.UserName }}<br />
                {{ clientUser.UserType }}
              </div>
              <img [src]="clientUser.ProfileImageURL" class="smallProfileImage float-left" *ngIf="clientUser.ProfileImageURL" />
              <div *ngIf="!clientUser.ProfileImageURL" class="smallProfileImage float-left bg-primary  text-center" style=" height: 25px; width: 25px; line-height: 25px;">{{ this.getProfileInitials(clientUser) }}</div>
              {{ clientUser.FirstName }} {{ clientUser.LastName }} <br />
              {{ clientUser.Email }}
            </button>

          </div>
        </div>
      </div>
      <div class="row" *ngIf="clientStatus!=null">
        <div class="col text-center ">
          <button class="btn btn-primary mr-1 " type="button" [routerLink]="['/client', currentItem?.ID, 'Companies']" [disabled]="loading">Companies</button>
          <button class="btn btn-primary mr-1 " type="button" [routerLink]="['/client', currentItem?.ID, 'Users']" [disabled]="loading">Users</button>
          <button class="btn btn-primary mr-1 " type="button" [routerLink]="['/client', currentItem?.ID, 'Permissions']" [disabled]="loading">Permissions</button>
          <button class="btn btn-primary mr-1 " type="button" [routerLink]="['/client', currentItem?.ID, 'Settings']" [disabled]="loading">Features & Settings</button>
          <button class="btn btn-primary mr-1 " type="button" [routerLink]="['/client', currentItem?.ID, 'AIUsage']" [disabled]="loading">AI Usage</button>
          <button class="btn btn-info mr-1 " *ngIf="canImpersonate" type="button" (click)="impersonateClient()" [disabled]="loading">Impersonate</button>


        </div>
      </div>
    </div>

  </div>
</div>
